import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import CancelDialog from '../CancelDialog';
import Tran_data_unlock_request from '../Tran_data_unlock_request';

function Tran_adii_inward() {

    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [msgText, setMsgText] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const currentDate = new Date();

    const [scrMode, setScrMode] = useState("");
    const [ttSettlementLocation, setTtSettlementLocation] = useState(null);
    const [locationCode, setLocationCode] = useState('0');
    const [location, setLocation] = useState("");
    const [dataList, setDataList] = useState([]);

    const [radioType, setRadioType] = useState("S");
    const [ttFromSrno, setTtFromSrno] = useState("");
    const [ttToSrno, setTtToSrno] = useState("");
    const [ttFromDate, setTtFromDate] = useState(new Date());
    const [ttToDate, setTtToDate] = useState(new Date());
    const [purSurrType, setPurSurrType] = useState("PP");
    const [headerDataPP, setHeaderDataPP] = useState([]);
    const [productDataPP, setProductDataPP] = useState([]);
    const [paymentDataPP, setPaymentDataPP] = useState([]);
    const [headerDataES, setHeaderDataES] = useState([]);
    const [productDataES, setProductDataES] = useState([]);
    const [paymentDataES, setPaymentDataES] = useState([]);
    const [showFaView, setShowFaView] = useState(false);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });

    const [key, setKey] = useState("PRODUCT");
    const [mainKey, setMainKey] = useState("PURCHASE");
    const [ppExists, setPpExists] = useState("0");
    const [esExists, setEsExists] = useState("0");
    const [settlementPayment, setSettlementPayment] = useState([]);
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [AD2currentBill, setAD2CurrentBill] = useState(null);
    const [hdrSrno, setHdrSrno] = useState(0);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setTtSettlementLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'PURCHASE_ADII'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setTtSettlementLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
        setDataList([])
    }

    const listData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (ttSettlementLocation === null) {
            $(".loader").hide();
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else if ((radioType === 'S' && !ttFromSrno) || (radioType === 'S' && !ttToSrno) || (radioType === 'D' && !ttFromDate) || (radioType === 'D' && !ttToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (radioType === 'S' && !ttFromSrno ? " From." : '');
            msg[i++] = (radioType === 'S' && !ttToSrno ? " To." : '');
            msg[i++] = (radioType === 'D' && !ttFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !ttToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                locationCode: locationCode,
                filterRadioType: radioType,
                filterFromSrno: ttFromSrno,
                filterToSrno: ttToSrno,
                filterFromDate: Common.dateYMD(ttFromDate),
                filterToDate: Common.dateYMD(ttToDate),
                purSurrType: purSurrType,

            }
            console.log("list data ", obj);
            Common.callApi(Common.apiAdiiInward, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setDataList(resp.list);
            });

        }
    }

    const viewList = (res) => {
        $(".loader").show();
        setScrMode('Q');
        const obj = {
            hdr_location: res.hdr_location,
            hdr_type: res.hdr_type,
            hdr_srno: res.hdr_srno
        }

        setHdrSrno(res.hdr_srno);
        console.log("View data ", obj);
        Common.callApi(Common.apiAdiiInward, [sid, 'view', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setProductDataPP(resp.productDataPP);
            setPaymentDataPP(resp.paymentDataPP);
            setHeaderDataPP(resp.headerDataPP);

            setProductDataES(resp.productDataES);
            setPaymentDataES(resp.paymentDataES);
            setHeaderDataES(resp.headerDataES);

            setPpExists(resp.ppExists)
            setEsExists(resp.esExists);
        });
        setAD2CurrentBill(res);
    }
    const cancelData = () => {

        setScrMode("");
    }

    const handleTabChange = (k) => {
        setKey(k);
    }

    const handleTabChangeMain = (k) => {
        setMainKey(k);
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: headerDataPP.hdr_location, trannumber: headerDataPP.hdr_srno, type: headerDataPP.hdr_type });
    }

    const handleFaViewES = () => {
        setShowFaView(true);
        setFaViewObject({ location: headerDataES.hdr_location, trannumber: headerDataES.hdr_srno, type: headerDataES.hdr_type });
    }
    function handlePrint() {
        $(".loader").show();
        const obj = {
            pType: 'ES',
            type: headerDataPP.hdr_type,
            location: headerDataPP.hdr_location,
            srno: headerDataPP.hdr_srno,
            nCorporate: null,
            nDealer: null,
            printFlag: 'D'
        }
        Common.callApi(Common.apiPrint, [sid, 'print', JSON.stringify(obj)], (result) => {
            if (result) {
                $(".loader").hide();
                var newWindow = window.open();
                newWindow.document.write(result);
            }
        })
    }
    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = ttFromDate;
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: purSurrType == 'PP' ? headerDataPP.hdr_srno : headerDataES.hdr_srno,
            type: 'ETT',
            pageright: 'PURCHASE_ADII',
            location: purSurrType == 'PP' ? headerDataPP.hdr_location : headerDataES.hdr_location,
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'ETT', trannumber: purSurrType == 'PP' ? headerDataPP.hdr_srno : headerDataES.hdr_srno, location: purSurrType == 'PP' ? headerDataPP.hdr_location : headerDataES.hdr_location, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'ETT',
            location: purSurrType == 'PP' ? headerDataPP.hdr_location : headerDataES.hdr_location,
            srno: purSurrType == 'PP' ? headerDataPP.hdr_srno : headerDataES.hdr_srno,
            productList: purSurrType == 'PP' ? productDataPP : productDataES,
            paymentList: purSurrType == 'PP' ? paymentDataPP : paymentDataES,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listData();
                setMsgText(resp.msg);
                setMsgBox(true);
                expireUnlock();
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }
    const expireUnlock = () => {
        if (scrMode == 'E' && unlockRequestType !== "SELF") {
            const obj = {
                srno: purSurrType == 'PP' ? headerDataPP.hdr_srno : headerDataES.hdr_srno,
                type: 'ETT',
                status: 'E',
                currentDate: Common.dateYMD(currentDate),
                pageright: 'PURCHASE_ADII'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const handleNextBill = () => {
        if (!hdrSrno || !locationCode) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: locationCode,
            type: "PP",
            hdr_tran_source: 'EREMIT'
        };

        // Common.callApi(Common.apiCommom, 'Nextbillexists', JSON.stringify(obj), (result) => {
        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                viewList({
                    hdr_srno: resp.srno,
                    hdr_location: resp.location || locationCode,
                    hdr_type: resp.type,
                });
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        })

    }
    const handlePrevBill = () => {
        if (!hdrSrno || !locationCode) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: locationCode,
            type: "PP",
            hdr_tran_source: 'EREMIT'
        };

        // Common.callApi(Common.apiCommom, 'Nextbillexists', JSON.stringify(obj), (result) => {
        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                viewList({
                    hdr_srno: resp.srno,
                    hdr_location: resp.location || locationCode,
                    hdr_type: resp.type,
                });
            } else {
                setMsgText("No Previous bill available.");
                setMsgBox(true);
            }
        })
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>ADII Inward</h3>
                    </Col>
                </Row>
                {
                    scrMode === "" ? <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={ttSettlementLocation}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleChangeLocation}
                                        isDisabled={branchDisable === "true"}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-4 col-6'>
                                <Form.Group>
                                    <Row style={{ marginTop: "30px" }}>
                                        <Col>
                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                        </Col><Col>
                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            {
                                radioType === 'S' ?
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                <Form.Control value={ttFromSrno}
                                                    maxLength={20}
                                                    onChange={(e) => Common.validateNumValue(e.target.value, setTtFromSrno)}
                                                    placeholder="From" />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                <Form.Control value={ttToSrno}
                                                    maxLength={20}
                                                    onChange={(e) => Common.validateNumValue(e.target.value, setTtToSrno)}
                                                    placeholder="To" />
                                            </Form.Group>
                                        </Col>

                                    </>
                                    :
                                    radioType === 'D' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={ttFromDate}
                                                        onChange={(date) => setTtFromDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={ttToDate}
                                                        onChange={(date) => setTtToDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        null
                            }
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Type</Form.Label>
                                    <Form.Select disabled={scrMode === "Q"} value={purSurrType} onChange={e => setPurSurrType(e.target.value)}>
                                        <option value="PP">Purchase</option>
                                        <option value="ES">Surrender</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                {
                                    userRight.query === "1" ?
                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => listData()}>List</Button>
                                        : null
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            {userRight.query === "1" ? <th></th> : null}
                                            <th>Type</th>
                                            <th>Sr No</th>
                                            <th>Date</th>
                                            <th>Party</th>
                                            <th>Forex</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataList.map((res, index) => (
                                                <tr key={index}>
                                                    {userRight.query === "1" ?
                                                        <td className="textCenter">
                                                            <span className="handCursor colorThemeBlue" onClick={() => viewList(res)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    <td>{res.hdr_type}</td>
                                                    <td>{res.hdr_srno}</td>
                                                    <td>{res.hdr_datedmy}</td>
                                                    <td>{res.bd_name}{res.ledger_name}</td>
                                                    <td>{res.hdr_forex_total}</td>
                                                    <td>{res.hdr_total_inr}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </> : <>
                        <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelData()}>Back</Button> {' '}
                        {
                            (scrMode === "Q") &&
                            <>
                                &nbsp;
                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={handleCancelBill}>Cancel Bill</Button>
                            </>
                        }
                        {
                            (scrMode === "Q" && +userRight.query === 1) &&
                            <>
                                &nbsp;
                                <Button variant="outline-primary  " className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                            </>
                        }
                        {
                            (scrMode === "Q" && +userRight.query === 1) &&
                            <>
                                &nbsp;
                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next Bill</Button>
                            </>
                        }

                        <Tabs activeKey={mainKey} defaultActiveKey="PURCHASE" onSelect={k => handleTabChangeMain(k)}>
                            <Tab eventKey="PURCHASE" title="Purchase">
                                {
                                    1 * ppExists === 1 ? <>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>

                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaView()}>FA View</Button>{' '}
                                                {
                                                    headerDataPP.hdr_type === "PP" ? <>
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handlePrint()}>Print</Button>
                                                    </> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col >
                                                <Form.Label><b>Srno:</b> {headerDataPP.hdr_srno}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>ZeneRemit Srno:</b> {headerDataPP.hdr_zeneremit_srno}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Location:</b>{headerDataPP.hdr_location}:{headerDataPP.entity_name} </Form.Label>
                                            </Col>
                                            <Col>
                                                <Form.Label><b>Date:</b> {headerDataPP.hdr_datedmy}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Forex Amount: </b>{headerDataPP.hdr_forex_total}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Total Amount:</b> {headerDataPP.hdr_total_inr}</Form.Label>
                                            </Col>
                                        </Row>
                                        <Tabs activeKey={key} defaultActiveKey="PRODUCTPP" onSelect={k => handleTabChange(k)}>
                                            <Tab eventKey="PRODUCTPP" title="Product">
                                                <Row>
                                                    <Col>
                                                        <h4>Product Info</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Product</th>
                                                                    <th>ISD</th>
                                                                    <th>Denomination</th>
                                                                    <th>Quantity</th>
                                                                    <th>Rate</th>
                                                                    <th>Amount</th>
                                                                    <th>Issuer</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    productDataPP.map((res, index) => (
                                                                        <tr key={index}>
                                                                            <td>{res.prd_product}</td>
                                                                            <td>{res.prd_isd}</td>
                                                                            <td>{res.prd_deno}</td>
                                                                            <td>{res.prd_qty}</td>
                                                                            <td>{res.prd_rate}</td>
                                                                            <td>{res.prd_amount}</td>
                                                                            <td>{res.prd_group} {res.prd_account} {res.mvli_ledger_name}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>

                                            </Tab>
                                            <Tab eventKey="PAYMENTPP" title="Payment">
                                                <Row>
                                                    <Col>
                                                        <h4>Payment Info</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        <th>Payment Type</th>
                                                                        <th>Ledger</th>
                                                                        <th>Amount</th>
                                                                        <th>Ref</th>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    paymentDataPP.map((res, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    res.tp_payment_type === "RC" ? "Receivables" :
                                                                                        res.tp_payment_type === "PB" ? "Payables" :
                                                                                            res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type
                                                                                }
                                                                            </td>
                                                                            <td>{res.prd_group} {res.prd_account} {res.mvli_ledger_name}</td>
                                                                            <td>{res.tp_amount}</td>
                                                                            <td>{res.tp_cheque}</td>

                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="COMMISSIONPP" title="Commission">
                                                <Row>
                                                    <Col>
                                                        <h4>Commission Info</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Commission Type</th>
                                                                    <th>Commission Value</th>
                                                                    <th>Commission </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    productDataPP.map((res, num) => (
                                                                        <tr key={num}>
                                                                            <td>{res.prd_commission_type === 'F' ? 'FLAT' :
                                                                                res.prd_commission_type === 'R' ? 'PERCANTAGE' :
                                                                                    res.prd_commission_type === 'P' ? 'PAISA' :
                                                                                        res.prd_commission_type}</td>
                                                                            <td>{res.prd_commission_value}</td>
                                                                            <td>{res.prd_commission}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                        </Tabs>
                                    </> : <>
                                        Nothing Here
                                    </>
                                }

                            </Tab>
                            <Tab eventKey="SURRENDER" title="Surrender">
                                {
                                    1 * esExists === 1 ? <>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>

                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaViewES()}>FA View</Button>{' '}

                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col >
                                                <Form.Label><b>Srno:</b> {headerDataES.hdr_srno}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>ZeneRemit Srno:</b> {headerDataES.hdr_zeneremit_srno}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Location:</b>{headerDataES.hdr_location}:{headerDataES.entity_name} </Form.Label>
                                            </Col>
                                            <Col>
                                                <Form.Label><b>Date:</b> {headerDataES.hdr_datedmy}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Forex Amount: </b>{headerDataES.hdr_forex_total}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Total Amount:</b> {headerDataES.hdr_total_inr}</Form.Label>
                                            </Col>
                                        </Row>
                                        <Tabs activeKey={key} defaultActiveKey="PRODUCTES" onSelect={k => handleTabChange(k)}>
                                            <Tab eventKey="PRODUCTES" title="Product">
                                                <Row>
                                                    <Col>
                                                        <h4>Product Info</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Product</th>
                                                                    <th>ISD</th>
                                                                    <th>Denomination</th>
                                                                    <th>Quantity</th>
                                                                    <th>Rate</th>
                                                                    <th>Amount</th>
                                                                    <th>Issuer</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    productDataES.map((res, index) => (
                                                                        <tr key={index}>
                                                                            <td>{res.prd_product}</td>
                                                                            <td>{res.prd_isd}</td>
                                                                            <td>{res.prd_deno}</td>
                                                                            <td>{res.prd_qty}</td>
                                                                            <td>{res.prd_rate}</td>
                                                                            <td>{res.prd_amount}</td>
                                                                            <td>{res.prd_group} {res.prd_account} {res.mvli_ledger_name}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>

                                            </Tab>
                                            <Tab eventKey="PAYMENTES" title="Payment">
                                                <Row>
                                                    <Col>
                                                        <h4>Payment Info</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        <th>Payment Type</th>
                                                                        <th>Ledger</th>
                                                                        <th>Amount</th>
                                                                        <th>Ref</th>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    paymentDataES.map((res, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    res.tp_payment_type === "RC" ? "Receivables" :
                                                                                        res.tp_payment_type === "PB" ? "Payables" :
                                                                                            res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type
                                                                                }
                                                                            </td>
                                                                            <td>{res.prd_group} {res.prd_account} {res.mvli_ledger_name}</td>
                                                                            <td>{res.tp_amount}</td>
                                                                            <td>{res.tp_cheque}</td>


                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Tab>

                                        </Tabs>
                                    </> : <>
                                        Nothing Here
                                    </>
                                }

                            </Tab>
                        </Tabs>
                    </>
                }
                <Row>&nbsp;</Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                    {msgTextYNBillDelete}
                </CancelDialog>
            </div>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default Tran_adii_inward